import { Action } from 'redux';
import * as R from 'ramda';

import { EOfficeType, IJsonQuery } from '@cian/api-models/common/json_query';

import { TThunkAction } from '../../types/redux';
import { EMetaStatus } from '../../types/filters';
import { FILTERS_GET_META_TYPE } from '../../constants/action_types';
import { getMeta as getMetaApi } from '../../api/getMeta';

export type TGetMetaType = 'filters/get_meta/status_changed';

export interface IGetMetaFailed extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Failed;
  error: string;
}

export interface IGetMetaSucceed extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Succeed;
  url: string;
  mapUrl: string;
  count: number;
}

export interface IGetMeta extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Loading;
}

export type TGetMeta = IGetMeta | IGetMetaFailed | IGetMetaSucceed;

let lastRequestId: Symbol;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getMeta(keepEvery?: boolean): TThunkAction<Promise<any>> {
  return (dispatch, getState, context) => {
    const requestId = (lastRequestId = Symbol());
    const getMetaTimeout = context.config.get<number>('frontendMainpage.getMetaTimeout') || 3000;

    dispatch<TGetMeta>({
      type: FILTERS_GET_META_TYPE,
      status: EMetaStatus.Loading,
    });

    const {
      filters: { jsonQuery },
    } = getState();

    /**
     * @todo Данный хак нужен для того, что бы при отправке на бек значение коворкингов считалось,
     * @todo как значение офисов, на беке сказали делать долго очень.
     * @todo Как только на беке смогут принимать значение для коворкингов следует выпилить,
     * @todo а то на это больно смотреть
     * @start
     */
    const newJsonJsonQuery = ((): IJsonQuery => {
      if (jsonQuery.office_type?.value.includes(EOfficeType.Coworking)) {
        const _jsonQuery = R.clone(jsonQuery);

        if (_jsonQuery.office_type) {
          _jsonQuery.office_type.value = Array.of<EOfficeType>(EOfficeType.Office);
        }

        return _jsonQuery;
      }

      return jsonQuery;
    })();
    /**
     * @end
     */

    return getMetaApi(context.makeRequest, getMetaTimeout, {
      jsonQuery: newJsonJsonQuery /** @todo Заменить костыль переменной newJsonJsonQuery на нормальное значение jsonQuery */,
    })
      .then(response => {
        if (!keepEvery && requestId !== lastRequestId) {
          return;
        }

        if (response.status === 'ok') {
          const { fullUrl, fullUrlWithoutSeo, url, mapUrl, count } = response.data;

          dispatch<TGetMeta>({
            type: FILTERS_GET_META_TYPE,
            status: EMetaStatus.Succeed,
            url: fullUrl || fullUrlWithoutSeo || url,
            mapUrl,
            count,
          });
        } else {
          dispatch<TGetMeta>({
            type: FILTERS_GET_META_TYPE,
            status: EMetaStatus.Failed,
            error: 'Произошла непредвиденная ошибка',
          });
        }
      })
      .catch(error => {
        // context.logger.error(error);
        console.error(error);

        if (!keepEvery && requestId !== lastRequestId) {
          return;
        }

        dispatch<TGetMeta>({
          type: FILTERS_GET_META_TYPE,
          status: EMetaStatus.Failed,
          error: 'Произошла непредвиденная ошибка',
        });
      });
  };
}
